import { Component } from "@angular/core";

@Component({
  selector: "vc-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss"],
})
export class SpinnerComponent { }
